var $ = jQuery.noConflict();

$(function () {
	jsonAnimations();
	$.fn.matchHeight._applyDataApi();
});